var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"point",staticStyle:{"z-index":"2000"},style:(_vm.fixedStyle)},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.affix),expression:"affix"}],style:(_vm.placeholderStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }